module.exports = __webpack_public_path__ + "static/img/brief_7.eba8329.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/brief_7.jpg
// module id = S8/7
// module chunks = 1